module.exports = __webpack_public_path__ + "img/52114129_L.b55c46e5.png";